module.exports = __webpack_public_path__ + "static/profile-30cac60b46e867ed8998ffc7030f8b1f.jpg";